import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useTheme as useMuiTheme } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export function StaffActionsMenu({
  anchorEl,
  open,
  onClose,
  staff,

  onDetail,
  onEdit,
  onToggleActive,

  onCreateLogin,
  onEditLogin,
  onEditPermissions,
}) {
  const theme = useMuiTheme();

  const isOwner = staff?.staffRole === 'OWNER' || staff?.role === 'OWNER';
  const hasAccount = Boolean(staff?.hasLoginAccount || staff?.username);
  const isInactive = staff?.active === false;

  const handle = (fn) => () => {
    fn?.(staff);
    onClose?.();
  };

  // ✅ MUI Menu Fragment kabul etmediği için children'ı array olarak hazırlıyoruz
  const items = [];

  items.push(
    <MDBox key="hdr" sx={{ px: 2, py: 1.25 }}>
      <MDTypography variant="caption" fontWeight="bold" sx={{ opacity: 0.9 }}>
        {staff?.fullName || 'İşlemler'}
      </MDTypography>
      <MDTypography variant="caption" sx={{ color: theme.palette.text.secondary }}>
        Hızlı aksiyonlar
      </MDTypography>
    </MDBox>
  );

  items.push(<Divider key="d0" />);

  items.push(
    <MenuItem key="detail" onClick={handle(onDetail)}>
      <ListItemIcon>
        <Icon sx={{ fontSize: 18 }}>visibility</Icon>
      </ListItemIcon>
      Detay
    </MenuItem>
  );

  items.push(
    <MenuItem key="edit" onClick={handle(onEdit)}>
      <ListItemIcon>
        <Icon sx={{ fontSize: 18 }}>edit</Icon>
      </ListItemIcon>
      Düzenle
    </MenuItem>
  );

  // ✅ Login / Yetkiler: Owner değilse
  if (!isOwner) {
    items.push(<Divider key="d1" />);

    // ✅ Panel Aç: SADECE AKTİF + HESAP YOK
    if (!hasAccount && !isInactive) {
      items.push(
        <MenuItem key="createLogin" onClick={handle(onCreateLogin)}>
          <ListItemIcon>
            <Icon sx={{ fontSize: 18 }}>vpn_key</Icon>
          </ListItemIcon>
          Panel Aç
        </MenuItem>
      );
    }

    // ✅ Hesap VARSA: aktif/pasif fark etmez düzenleme seçenekleri görünür
    if (hasAccount) {
      items.push(
        <MenuItem key="editLogin" onClick={handle(onEditLogin)}>
          <ListItemIcon>
            <Icon sx={{ fontSize: 18 }}>manage_accounts</Icon>
          </ListItemIcon>
          Giriş Bilgilerini Düzenle
        </MenuItem>
      );

      items.push(
        <MenuItem key="editPerms" onClick={handle(onEditPermissions)}>
          <ListItemIcon>
            <Icon sx={{ fontSize: 18 }}>shield</Icon>
          </ListItemIcon>
          Yetkileri Düzenle
        </MenuItem>
      );
    }

    // ✅ Aktif/Pasif: Owner ise hiç gösterme
    items.push(<Divider key="d2" />);
    items.push(
      <MenuItem key="toggleActive" onClick={handle(onToggleActive)}>
        <ListItemIcon>
          <Icon sx={{ fontSize: 18 }}>{staff?.active ? 'block' : 'check_circle'}</Icon>
        </ListItemIcon>
        {staff?.active ? 'Pasife Al' : 'Aktifleştir'}
      </MenuItem>
    );
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '18px',
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'hidden',
          minWidth: 260,
          boxShadow: theme.shadows[10],
        },
      }}
    >
      {items}
    </Menu>
  );
}
